import { render, staticRenderFns } from "./ProposalsSearch.vue?vue&type=template&id=2f94ad8c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ProposalsSearch.vue?vue&type=script&lang=js&"
export * from "./ProposalsSearch.vue?vue&type=script&lang=js&"
import style0 from "./ProposalsSearch.vue?vue&type=style&index=0&id=2f94ad8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f94ad8c",
  null
  
)

export default component.exports